var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCircle = function SvgPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.904 13.25h1.5v-7.5h-1.5zm3.692 0h1.5v-7.5h-1.5zM9.502 19q-1.972 0-3.706-.748a9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016A9.25 9.25 0 0 1 0 9.502Q0 7.53.748 5.796a9.6 9.6 0 0 1 2.03-3.016A9.6 9.6 0 0 1 5.794.748 9.25 9.25 0 0 1 9.498 0q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016A9.25 9.25 0 0 1 19 9.498q0 1.972-.748 3.706a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03A9.25 9.25 0 0 1 9.502 19M9.5 17.5q3.35 0 5.675-2.325T17.5 9.5t-2.325-5.675T9.5 1.5 3.825 3.825 1.5 9.5t2.325 5.675T9.5 17.5"
  })));
};
export default SvgPauseCircle;